import { render, staticRenderFns } from "./contactPage.vue?vue&type=template&id=72df6ff8&scoped=true&"
import script from "./contactPage.vue?vue&type=script&lang=js&"
export * from "./contactPage.vue?vue&type=script&lang=js&"
import style0 from "./contactPage.vue?vue&type=style&index=0&id=72df6ff8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df6ff8",
  null
  
)

export default component.exports